import { Dispatch } from '@reduxjs/toolkit';

import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { CaseQuery } from 'dashboard/models/case-query';
import { setCaseQueries } from 'dashboard/redux/actions/case-queries';
import { ApiEndpoint } from 'lib/interfaces/api';

export function loadCaseQueryList({ currentCaseTemplateId }: { currentCaseTemplateId: string }) {
  return async (dispatch: Dispatch) => {
    const caseQueriesResponse = await SessionClientDashboard.listResource<
      CaseQuery,
      { 'case-template-id': string }
    >(ApiEndpoint.CaseQuery, {
      filter: {
        'case-template-id': currentCaseTemplateId,
      },
    });

    dispatch(setCaseQueries(caseQueriesResponse.data));
  };
}
